// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBOu1LpyzZrQczmm-lYy-61YUzla_sChIc",
    authDomain: "otc-senosiain.firebaseapp.com",
    databaseURL: "https://otc-senosiain.firebaseio.com",
    projectId: "otc-senosiain",
    storageBucket: "otc-senosiain.appspot.com",
    messagingSenderId: "144178894364",
    appId: "1:144178894364:web:6a90cf21bf6d8ab221b1d9",
    measurementId: "G-R22LXE0JRV",
  },
  APICP: `https://api.copomex.com/query/info_cp/`,
  TOKEN: `?token=e5ea71f7-f7d0-441b-ae83-7088fc702ba6`,
};
//export const firebaseConfig = {};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
